import React from "react";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import TimeInputWithArrows from "components/TimeInputWithArrows";
import "styles/components/TimeIntervalEditor.scss";

const TimeIntervalEditor = ({
	newInterval,
	newIntervalErrors = {},
	optionTimeTypeList,
	onChange,
	onRemoveDraft,
	editorRef,
}) => {
	const { t } = useTranslation();
	return (
		<div className="time-interval-editor" ref={editorRef}>
			<FormGroup className="form-group time-interval-editor__type" controlId="time_type_id">
				<FormLabel>{t("common.type")}</FormLabel>
				<FormControl
					placeholder={t("shifts.form.selectTypePlaceholder")}
					isInvalid={newIntervalErrors.time_type_id !== undefined}
					onChange={onChange}
					value={newInterval.time_type_id}
					as="select"
				>
					<option value="">{t("shifts.form.select")}</option>
					{optionTimeTypeList}
				</FormControl>
			</FormGroup>

			<FormGroup className="form-group time-interval-editor__time" controlId="start">
				<FormLabel>{t("common.start")}</FormLabel>
				<TimeInputWithArrows
					id="start"
					value={newInterval.start}
					onChange={onChange}
					isInvalid={newIntervalErrors.start !== undefined}
					placeholder="hh:mm"
					showDecorators={newIntervalErrors.start === undefined}
					autoFocus
					nextInputId="end"
				/>
			</FormGroup>

			<FormGroup className="form-group time-interval-editor__time" controlId="end">
				<FormLabel>{t("common.end")}</FormLabel>
				<TimeInputWithArrows
					id="end"
					value={newInterval.end}
					onChange={onChange}
					isInvalid={newIntervalErrors.end !== undefined}
					placeholder="hh:mm"
					showDecorators={newIntervalErrors.end === undefined}
				/>
			</FormGroup>

			<div className="time-interval-editor__actions">
				<button
					type="button"
					className="btn btn-icon time-interval-editor__remove-btn"
					onClick={onRemoveDraft}
					aria-label={t("shifts.form.clearPeriodAriaLabel")}
				>
					<FiTrash2 />
				</button>
			</div>
		</div>
	);
};

export default TimeIntervalEditor;
